import { Component, Input, OnInit, inject, DestroyRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { translate } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GenericErrorComponent } from 'src/app/components/generic-error/generic-error.component';
import { Constants } from 'src/app/models/constants';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';

@Component({
    selector: 'app-component-dependency',
    templateUrl: './component-dependency.component.html',
    styleUrls: ['./component-dependency.component.scss'],
    standalone: false
})
export class ComponentDependencyComponent  implements OnInit {

  @Input() missingDependency: any;
private destroyRef = inject(DestroyRef);

  constructor(public sidenavService: SidenavService, private solutionsService: SolutionsService,
    private toastrService: CustomToastrService, public dialog: MatDialog) {
  }
  
  ngOnInit(): void {
  }
}

